module.exports = __webpack_public_path__ + "static/media/paper-plane.5c938cbc.png";